<template><!--陌撩漂流瓶账号注销协议-->
  <div class="privacyList">

    <div>

      <div style="text-align: center; margin: 20px 0;">
        <h2>陌撩漂流瓶账号注销协议</h2>
      </div>

      <p><b>重要提示：请您在申请注销账号前仔细阅读本协议，一旦您提交注销申请并完成验证，即视为您已充分理解并同意本协议全部内容。</b></p>
      <h2>一、定义与范围</h2>
      <p>账号：指您在陌撩漂流瓶平台（包括但不限于陌撩漂流瓶 APP及相关关联服务）注册并使用的账号，包含账号 ID、注册信息及该账号下的所有数据。</p>
      <p>注销：指您主动申请终止使用该账号及陌撩漂流瓶提供的全部或部分服务，陌撩漂流瓶根据本协议及相关规则对账号进行处理的行为。</p>
      <p>本协议适用于您与陌撩漂流瓶（运营主体：睢宁陌撩信息科技有限公司）就账号注销相关事宜的约定，是《用户协议》《隐私政策》的补充条款，与其具有同等法律效力。</p>
      <h2>二、注销条件</h2>
      <p>您申请注销账号需同时满足以下条件，否则陌撩漂流瓶有权拒绝您的注销申请：</p>
      <ul>
        <li>账号处于正常状态（无被封禁、冻结等限制）；</li>
        <li>账号内无未完成的交易（如未结算的礼物收入、未消耗的虚拟礼物、未完成的订单等）；</li>
        <li>账号无未处理的投诉、举报或纠纷；</li>
        <li>您已完成陌撩漂流瓶要求的身份验证（如短信验证、人脸识别等），以确认您为账号合法持有人。</li>
      </ul>
      <h2>三、注销后果</h2>
      <p>您确认，账号注销后将产生以下不可逆转的后果，且陌撩漂流瓶无义务为您恢复账号或相关数据：</p>
      <ul>
        <li>账号无法再登录或使用陌撩漂流瓶的任何服务，包括但不限于聊天、附近的人、动态发布等；</li>
        <li>账号下的所有数据将被处理：个人信息（如头像、昵称、手机号、聊天记录等）将根据《隐私政策》及法律法规要求进行删除或匿名化处理；</li>
        <li>虚拟资产（如陌撩币、礼物记录等）将被清零，且无法找回或折现；</li>
        <li>账号相关的历史动态、互动记录（如点赞、评论、关注关系等）将被删除或隐藏；</li>
        <li>与账号相关的协议关系终止，但法律法规另有规定或本协议另有约定的除外；</li>
        <li>您将无法使用该账号注册新的陌撩漂流瓶账号（同一手机号可能存在注册限制，具体以平台规则为准）。</li>
      </ul>
      <h2>四、您的声明与承诺</h2>
      <ul>
        <li>您确认本次注销申请是您的真实意愿，且您对该账号享有合法使用权；</li>
        <li>您已妥善处理账号注销前的所有事务，包括但不限于备份重要数据、结清相关费用、告知好友账号注销事宜等；</li>
        <li>您承诺注销账号后，不会以任何理由要求陌撩漂流瓶恢复账号、数据或虚拟资产，也不会追究陌撩漂流瓶因此产生的相关责任；</li>
        <li>如因您未满足注销条件或违反本协议导致的任何纠纷、损失（包括但不限于第三方索赔），由您自行承担全部责任。</li>
      </ul>
      <h2>五、陌撩漂流瓶的权利与义务</h2>
      <ul>
        <li>陌撩漂流瓶有权对您的注销申请进行审核，核实您是否满足注销条件；</li>
        <li>审核通过后，陌撩漂流瓶将在约定时限内（通常为 15 个自然日，具体以页面提示为准）完成账号注销及数据处理；</li>
        <li>注销过程中，如发现账号存在异常（如涉嫌违规、被他人投诉等），陌撩漂流瓶有权暂停或终止注销流程，并告知您原因；</li>
        <li>陌撩漂流瓶将按照法律法规及《隐私政策》的要求，妥善处理您的个人信息，保障信息安全；</li>
        <li>注销完成后，陌撩漂流瓶将通过您预留的联系方式（如短信）告知您注销结果。</li>
      </ul>
      <h2>六、法律适用与争议解决</h2>
      <p>本协议的订立、效力、解释及争议解决均适用中华人民共和国法律（不含港澳台地区法律）；</p>
      <p>因本协议引起的或与本协议有关的任何争议，您可先与陌撩漂流瓶客服协商解决；协商不成的，任何一方均有权向陌撩漂流瓶运营主体所在地有管辖权的人民法院提起诉讼。</p>
      <h2>七、其他</h2>
      <ul>
        <li>陌撩漂流瓶有权根据法律法规变化、业务调整等情况，对本协议进行修改，修改后的协议将在陌撩漂流瓶平台公布，公布后即生效。若您不同意修改后的内容，应停止使用账号及相关服务；</li>
        <li>本协议未尽事宜，参照《用户协议》《隐私政策》及相关法律法规执行；</li>
        <li>本协议自您提交注销申请并完成验证之日起生效。</li>
      </ul>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>

<style>

.privacyList {
  width: 92%;
  max-width: 960px;
  margin: auto;
  font-size: 14px;
  line-height: 26px;
}

.privacyList div {
  margin-bottom: 8px;
}

.privacyList h3 {
  margin: 8px 0;
}

.privacyList h4 {
  margin: 2px 0;
}

p {
  margin: 4px 0;
}

</style>
